/* UltimateKicks — The Wall
   A curved 3D shelf of shoeboxes. Drag, swipe, arrow keys or buttons
   rotate it; the front box drives the label underneath. */
(function () {
  if (window.ukWallLoaded) return;
  window.ukWallLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function geometry(width) {
    if (width < 750) return { step: 30, radius: 480, pxPerStep: 110 };
    return { step: 17, radius: 1150, pxPerStep: 170 };
  }

  function setup(root) {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var stage = root.querySelector('.uk-wall__stage');
    var ring = root.querySelector('.uk-wall__ring');
    var all = Array.prototype.slice.call(root.querySelectorAll('.uk-wall__item'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('.uk-wall__chip'));
    var counter = root.querySelector('.uk-wall__count');
    var prevBtn = root.querySelector('[data-wall-prev]');
    var nextBtn = root.querySelector('[data-wall-next]');
    var fields = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-f]'), function (el) {
      fields[el.getAttribute('data-f')] = el;
    });

    if (!all.length) return;
    root.classList.add('is-live');

    var items = all.slice();
    var position = 0; // may be fractional while dragging
    var drag = null;
    var moved = false;

    var state = null;

    function priceForSize(el, size) {
      var s = el.dataset.sizePrices || '';
      var key = '|' + size + '=';
      var i = s.indexOf(key);
      if (i === -1) return '';
      var rest = s.slice(i + key.length);
      return rest.slice(0, rest.indexOf('|'));
    }

    // Boxes drop onto the shelf one after another after a filter change.
    var enterTimer;
    function playEntrance() {
      if (reduceMotion) return;
      clearTimeout(enterTimer);
      items.forEach(function (el, i) {
        var box = el.firstElementChild;
        if (!box) return;
        el.classList.remove('is-entering');
        box.style.animationDelay = Math.min(i, 8) * 55 + 'ms';
      });
      void ring.offsetWidth;
      items.forEach(function (el) { el.classList.add('is-entering'); });
      enterTimer = setTimeout(function () {
        all.forEach(function (el) { el.classList.remove('is-entering'); });
      }, 1100);
    }

    function clamp(v) {
      return Math.max(0, Math.min(items.length - 1, v));
    }

    function render(animate) {
      var g = geometry(root.clientWidth);
      ring.classList.toggle('is-dragging', !animate || reduceMotion);
      ring.style.transform = 'translateZ(' + -g.radius + 'px)';

      all.forEach(function (el) {
        var i = items.indexOf(el);
        if (i === -1) {
          el.hidden = true;
          return;
        }
        el.hidden = false;
        var angle = (i - position) * g.step;
        var visible = Math.abs(angle) < 92;
        el.style.transform = 'rotateY(' + angle + 'deg) translateZ(' + g.radius + 'px)';
        el.style.opacity = visible ? String(Math.max(0.15, 1 - Math.abs(angle) / 100)) : '0';
        el.style.pointerEvents = visible ? 'auto' : 'none';
        el.classList.toggle('is-front', i === Math.round(position));
        var box = el.firstElementChild;
        if (box) {
          if (state && state.size) box.setAttribute('data-tag', 'EU ' + state.size);
          else box.removeAttribute('data-tag');
        }
      });

      updateLabel();
    }

    function updateLabel() {
      var current = items[Math.round(position)];
      if (!current) return;
      var d = current.dataset;
      if (fields.title) fields.title.textContent = d.title;
      if (fields.brand) fields.brand.textContent = d.brand;
      var sizePrice = state && state.size ? priceForSize(current, state.size) : '';
      if (fields.priceLabel) fields.priceLabel.textContent = sizePrice ? 'En EU ' + state.size : 'Desde';
      if (fields.price) fields.price.textContent = sizePrice || d.price;
      if (fields.sizes) {
        var n = parseInt(d.sizes, 10) || 0;
        fields.sizes.textContent = n > 1 ? n + ' tallas disponibles' : 'Talla única';
      }
      if (fields.url) fields.url.setAttribute('href', d.url);
      if (counter) counter.textContent = Math.round(position) + 1 + ' / ' + items.length;
      if (prevBtn) prevBtn.disabled = Math.round(position) === 0;
      if (nextBtn) nextBtn.disabled = Math.round(position) === items.length - 1;
      if (typeof paintSaved === 'function') paintSaved();
    }

    function goTo(i) {
      position = clamp(Math.round(i));
      render(true);
    }

    /* Buttons and keyboard */
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(position - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(position + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.target.tagName === 'SELECT') return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(position - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(position + 1); }
    });

    /* Drag / swipe */
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { x: e.clientX, start: position, id: e.pointerId };
      moved = false;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!moved && Math.abs(dx) > 6) {
        moved = true;
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (!moved) return;
      var g = geometry(root.clientWidth);
      position = clamp(drag.start - dx / g.pxPerStep);
      render(false);
    });
    function endDrag() {
      if (!drag) return;
      drag = null;
      if (moved) goTo(position);
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    /* A click after a drag does nothing; a click on a side box brings it forward */
    stage.addEventListener('click', function (e) {
      var item = e.target.closest('.uk-wall__item');
      if (moved) { e.preventDefault(); moved = false; return; }
      if (item && !item.classList.contains('is-front')) {
        e.preventDefault();
        goTo(items.indexOf(item));
      }
    }, true);

    /* Brand filters */
    /* Filters: brand + my size + saved, combined */
    var sizeSelect = root.querySelector('[data-wall-size]');
    var savedBtn = root.querySelector('[data-wall-saved]');
    var savedCount = root.querySelector('[data-saved-count]');
    var saveBtn = root.querySelector('[data-wall-save]');
    var emptyEl = root.querySelector('[data-wall-empty]');
    var resetBtn = root.querySelector('[data-wall-reset]');
    var labelEl = root.querySelector('.uk-wall__label');
    var controlsEl = root.querySelector('.uk-wall__controls');

    function readLS(key, fallback) {
      try { var v = localStorage.getItem(key); return v === null ? fallback : JSON.parse(v); }
      catch (e) { return fallback; }
    }
    function getSaved() { return window.ukStore ? window.ukStore.getSaved() : readLS('uk-saved', []); }
    function getSize() { return window.ukStore ? window.ukStore.getSize() : readLS('uk-size', ''); }

    state = { brand: 'all', size: '', saved: false };

    // Size options come from what's actually on the shelf, sorted numerically.
    function sizeValue(s) {
      var m = s.match(/^(\d+)\s+(1|2)\/3$/);
      if (m) return parseFloat(m[1]) + (m[2] === '1' ? 1 / 3 : 2 / 3);
      return parseFloat(s) || 0;
    }
    if (sizeSelect) {
      var seen = {};
      all.forEach(function (el) {
        (el.dataset.sizeList || '').split('|').forEach(function (s) { if (s) seen[s] = true; });
      });
      Object.keys(seen).sort(function (a, b) { return sizeValue(a) - sizeValue(b); }).forEach(function (s) {
        var o = document.createElement('option');
        o.value = s; o.textContent = s;
        sizeSelect.appendChild(o);
      });
      var stored = getSize();
      if (stored && seen[stored]) { state.size = stored; sizeSelect.value = stored; }
      sizeSelect.addEventListener('change', function () {
        state.size = sizeSelect.value;
        if (window.ukStore) window.ukStore.setSize(state.size);
        applyFilters();
      });
    }

    function paintSaved() {
      var list = getSaved();
      if (savedCount) savedCount.textContent = list.length;
      if (saveBtn) {
        var current = items[Math.round(position)];
        var on = !!current && list.indexOf(current.dataset.handle) !== -1;
        saveBtn.classList.toggle('is-saved', on);
        saveBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        saveBtn.textContent = on ? 'Guardado' : 'Guardar';
      }
    }

    function applyFilters() {
      var saved = getSaved();
      items = all.filter(function (el) {
        if (state.brand !== 'all' && el.dataset.brand !== state.brand) return false;
        if (state.size && (el.dataset.sizeList || '').indexOf('|' + state.size + '|') === -1) return false;
        if (state.saved && saved.indexOf(el.dataset.handle) === -1) return false;
        return true;
      });
      position = 0;
      var none = items.length === 0;
      if (emptyEl) emptyEl.hidden = !none;
      if (labelEl) labelEl.hidden = none;
      if (controlsEl) controlsEl.hidden = none;
      render(true);
      playEntrance();
      paintSaved();
    }

    chips.forEach(function (chip) {
      if (!chip.hasAttribute('data-brand')) return;
      chip.addEventListener('click', function () {
        state.brand = chip.getAttribute('data-brand');
        chips.forEach(function (c) {
          if (c.hasAttribute('data-brand')) c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    if (savedBtn) savedBtn.addEventListener('click', function () {
      state.saved = !state.saved;
      savedBtn.setAttribute('aria-pressed', state.saved ? 'true' : 'false');
      applyFilters();
    });

    if (saveBtn) saveBtn.addEventListener('click', function () {
      var current = items[Math.round(position)];
      if (!current || !window.ukStore) return;
      var on = window.ukStore.toggleSaved(current.dataset.handle);
      if (window.ukToast) window.ukToast(on ? 'Guardado en tu estantería' : 'Quitado de tu estantería');
      if (state.saved && !on) applyFilters(); else paintSaved();
    });

    if (resetBtn) resetBtn.addEventListener('click', function () {
      state = { brand: 'all', size: '', saved: false };
      if (sizeSelect) sizeSelect.value = '';
      if (savedBtn) savedBtn.setAttribute('aria-pressed', 'false');
      chips.forEach(function (c) {
        if (c.hasAttribute('data-brand')) c.setAttribute('aria-pressed', c.getAttribute('data-brand') === 'all' ? 'true' : 'false');
      });
      applyFilters();
    });

    document.addEventListener('uk:saved', paintSaved);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { render(false); }, 120);
    });

    applyFilters();
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-uk-wall]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
